import React, { useState } from 'react';
import Badge from 'react-bootstrap/Badge';
import ReactJsonView from 'react-json-view';
import '../MqttEvent/MqttEvent.css';

function DeviceDeleteEvent({ event }) {
    const [showJson, setShowJson] = useState(false);
    const attrs = event.payload?.attributes || {};
    const { device_name, device_type, device_location, device_id } = attrs;

    return (
        <div style={{ maxWidth: '100%', overflow: 'hidden' }}>

            {/* Row 1: device info */}
            <div className="d-flex align-items-center flex-wrap gap-1 mb-1">
                {device_type && (
                    <Badge bg="secondary" style={{ fontSize: '0.75rem' }}>{device_type}</Badge>
                )}
                {device_id && (
                    <Badge bg="secondary" style={{ fontSize: '0.75rem', fontFamily: 'monospace' }}>{device_id}</Badge>
                )}
                {device_name && (
                    <Badge bg="warning" text="dark" style={{ fontSize: '0.75rem' }}>{device_name}</Badge>
                )}
                {device_location && (
                    <Badge bg="light" text="dark" style={{ fontSize: '0.75rem' }}>📍 {device_location}</Badge>
                )}
            </div>

            {/* Row 2: {} toggle */}
            <div className="d-flex align-items-center gap-1">
                <Badge
                    bg={showJson ? 'secondary' : 'dark'}
                    style={{ cursor: 'pointer', fontSize: '0.75rem', userSelect: 'none', lineHeight: '1.5', padding: '0.35em 0.65em' }}
                    onClick={() => setShowJson(s => !s)}
                    title="Toggle raw JSON"
                >
                    {'{}'}
                </Badge>
            </div>

            {/* Raw JSON */}
            {showJson && (
                <div style={{ marginTop: '6px', maxWidth: '100%', overflowX: 'auto' }}>
                    <ReactJsonView
                        src={event.payload}
                        className="mqttEventPayload"
                        theme="ocean"
                        borderStyle="none"
                        name={false}
                        displayObjectSize={false}
                        displayDataTypes={false}
                        collapsed={2}
                    />
                </div>
            )}
        </div>
    );
}

export default DeviceDeleteEvent;
